const PILLARS = [
  {
    label: "Location",
    title: "Beachfront at Sorake",
    sub: "Steps to the legendary right-hander",
  },
  {
    label: "Rates",
    title: "From $45 / Night",
    sub: "Monthly remote work from $700",
  },
  {
    label: "Surf Logistics",
    title: "Door-to-Door Cargo",
    sub: "Board shipment from Medan & Padang",
  },
  {
    label: "Facilities",
    title: "Pool & Rooftop Café",
    sub: "Reliable WiFi & Mini Gym",
  },
];

const Pillars = () => (
  <section className="border-b border-sand-200 bg-sand-50 py-8" data-testid="pillars-section">
    <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-6">
      {PILLARS.map((p) => (
        <div key={p.label} className="border-l-2 border-ocean-700 pl-4">
          <span className="text-xs font-mono-clean text-fog uppercase">{p.label}</span>
          <p className="font-display font-semibold text-lg text-ocean-900 mt-1">{p.title}</p>
          <p className="text-xs text-fog mt-0.5">{p.sub}</p>
        </div>
      ))}
    </div>
    <div className="max-w-7xl mx-auto px-6 mt-8 pt-8 border-t border-sand-200">
      <p className="text-sm text-fog leading-relaxed max-w-3xl">
        Welcome to Raffiel Nias, a beachfront surf hotel at Sorake Beach on
        Lagundri Bay, South Nias — one of Indonesia's most iconic surf
        destinations. We host international surfers, long-stay remote workers,
        families and groups with ocean view rooms from $45 a night, monthly
        stays from $700, a swimming pool, rooftop café and beachside
        restaurant, plus surf lessons, surf photography, airport transfers and
        board bag shipment from Medan and Padang.
      </p>
    </div>
  </section>
);

export default Pillars;
